var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    [
      _c(
        "Modal",
        {
          attrs: {
            title: "登录",
            "class-name": "vertical-center-modal my-modal",
            "mask-closable": false,
            loading: _vm.submitLoading,
            "ok-text": "登 录",
            "cancel-text": "暂不登录",
            width: "400",
            "footer-hide": _vm.tabName == "s2"
          },
          on: { "on-ok": _vm.ok, "on-cancel": _vm.cancel },
          model: {
            value: _vm.modalShow,
            callback: function($$v) {
              _vm.modalShow = $$v
            },
            expression: "modalShow"
          }
        },
        [
          _c(
            "div",
            {
              staticStyle: { color: "#f60", "text-align": "left" },
              attrs: { slot: "header" },
              slot: "header"
            },
            [
              _c(
                "Tabs",
                {
                  on: { "on-click": _vm.handelChangeTab },
                  model: {
                    value: _vm.tabName,
                    callback: function($$v) {
                      _vm.tabName = $$v
                    },
                    expression: "tabName"
                  }
                },
                [
                  _c("TabPane", { attrs: { label: "账号登录", name: "s1" } }),
                  _vm._v(" "),
                  _c("TabPane", { attrs: { label: "扫码登录", name: "s2" } })
                ],
                1
              )
            ],
            1
          ),
          _vm._v(" "),
          _vm.tabName == "s1"
            ? [
                _c(
                  "Form",
                  {
                    ref: "formCustomRef",
                    attrs: {
                      model: _vm.formData,
                      rules: _vm.ruleCustom,
                      "label-width": 80
                    }
                  },
                  [
                    _c(
                      "FormItem",
                      { attrs: { label: "手机号", prop: "phone" } },
                      [
                        _c("Input", {
                          staticStyle: { width: "255px" },
                          attrs: {
                            prefix: "ios-contact",
                            placeholder: "输入手机号码",
                            maxlength: "11"
                          },
                          model: {
                            value: _vm.formData.phone,
                            callback: function($$v) {
                              _vm.$set(_vm.formData, "phone", $$v)
                            },
                            expression: "formData.phone"
                          }
                        })
                      ],
                      1
                    ),
                    _vm._v(" "),
                    _c(
                      "FormItem",
                      { attrs: { label: "验证码", prop: "captcha" } },
                      [
                        _c("Input", {
                          staticStyle: { width: "150px" },
                          attrs: {
                            prefix: "ios-unlock",
                            placeholder: "输入短信验证码",
                            maxlength: "6"
                          },
                          model: {
                            value: _vm.formData.captcha,
                            callback: function($$v) {
                              _vm.$set(_vm.formData, "captcha", $$v)
                            },
                            expression: "formData.captcha"
                          }
                        }),
                        _vm._v(" "),
                        _c(
                          "Button",
                          {
                            staticStyle: { width: "102px" },
                            attrs: { disabled: _vm.countdown > 0 },
                            on: { click: _vm.handleGetCode }
                          },
                          [
                            _vm._v(
                              _vm._s(
                                _vm.countdown > 0
                                  ? "重 发(" + _vm.countdown + "s)"
                                  : "发送验证码"
                              )
                            )
                          ]
                        )
                      ],
                      1
                    )
                  ],
                  1
                )
              ]
            : _vm._e(),
          _vm._v(" "),
          _vm.tabName == "s2"
            ? [
                _c("div", { staticClass: "qrcode-login" }, [
                  _vm.qrData.img
                    ? _c("div", { staticClass: "qrcode" }, [
                        _c("img", {
                          staticStyle: {
                            width: "160px",
                            height: "160px",
                            display: "block"
                          },
                          attrs: { src: _vm.qrData.img, alt: "扫码登录" }
                        })
                      ])
                    : _vm._e(),
                  _vm._v(" "),
                  _c("p", [_vm._v(_vm._s(_vm.qrData.text))])
                ])
              ]
            : _vm._e()
        ],
        2
      )
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-f7af2618", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-f7af2618","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/LoginModal.vue
// module id = null
// module chunks = 